module.exports = __webpack_public_path__ + "img/stop_btn.d8fba55d.png";